<template>
  <div id="shift-token-report-page">
    <vx-card class="cHeight">

      <!-- DATE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Date</span>
        </vs-col>

        <vs-col class="w-1/4">
          <flat-pickr v-model="date" :config="dateConfig" class="w-full inputField" />
        </vs-col>
      </vs-row>

      <!-- DOCTOR -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Doctor</span>
        </vs-col>

        <vs-col class="w-1/4">
          <vs-select v-model="doctorId" class="w-full inputField">
            <vs-select-item
              v-for="doc in doctorList"
              :key="doc.id"
              :value="doc.id"
              :text="doc.name"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- SHIFT -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Shift</span>
        </vs-col>

        <vs-col class="w-1/4">
          <vs-select v-model="shiftId" class="w-full inputField">
            <vs-select-item
              v-for="shift in shiftList"
              :key="shift.shiftId"
              :value="shift.shiftId"
              :text="shift.shiftName"
            />
          </vs-select>
        </vs-col>
      </vs-row>

      <!-- EXPORT TYPE -->
      <vs-row class="mb-6">
        <vs-col class="w-1/6 topPad">
          <span class="label">Export Type</span>
        </vs-col>

        <vs-col class="w-2/3">
          <vs-radio v-model="reportType" vs-value="PDF">PDF</vs-radio>
          <vs-radio v-model="reportType" vs-value="EXCEL" style="margin-left:20px">Excel</vs-radio>
        </vs-col>
      </vs-row>

      <!-- BUTTONS -->
      <vs-row style="margin-top:30px;">
        <vs-col class="w-full sm:w-1/6"></vs-col>

        <vs-col class="w-full sm:w-1/3">
          <vs-button @click="generateReport" style="margin-right:20px;">
            Preview
          </vs-button>

          <vs-button @click="clearForm">
            Clear
          </vs-button>
        </vs-col>
      </vs-row>

    </vx-card>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {

  components: { flatPickr },

  data() {
    return {
      date: null,

      doctorId: null,
      doctorList: [],

      shiftId: null,
      shiftList: [
  { shiftId: null, shiftName: "ALL" }
],

      reportType: 'PDF',

      dateConfig: {
        dateFormat: "d-m-Y"
      }
    }
  },

  mounted() {
    this.getDoctorList();
    //this.getShiftList();
  },
  watch: {
  doctorId() {
    if (this.date) {
      this.getShiftList();
    }
  },
  date() {
    if (this.date) {
      this.getShiftList();
    }
  }
},

  methods: {

    formatDate(date) {
      if (!date) return null;
      return date.split('-').reverse().join('-');
    },

    clearForm() {
      this.date = null;
      this.doctorId = null;
      this.shiftId = null;
      this.reportType = 'PDF';
    },

    async getDoctorList() {
      var request = {
        companyId: this.$session.get('companyId')
      };

      const response = await this.$http.post(
        "getdoctorlist",
        JSON.stringify(request),
        { headers: { "Content-Type": "application/json" } }
      );

      this.doctorList = [];

      this.doctorList.push({ id: null, name: "ALL" });
      response.data.data.forEach((value) => {
        this.doctorList.push(value);
      });
    },

  async getShiftList() {
  try {
    var request = {
      companyId: this.$session.get('companyId'),
      filter: {
        doctorId: this.doctorId,
        date: this.formatDate(this.date)
      }
    };

    const response = await this.$http.post(
      "getdoctorshifts",
      JSON.stringify(request),
      { headers: { "Content-Type": "application/json" } }
    );

    console.log("Shift API:", response);

    const shifts = response.data.data.shifts;

    this.shiftList = [];

    this.shiftList.push({
  shiftId: null,
  shiftName: "ALL"
});
    shifts.forEach((shift) => {
      this.shiftList.push(shift);
    });

  } catch (error) {
    console.error("Shift API Error:", error);
  }
},
    generateReport() {
      if (this.reportType === 'PDF') {
        this.getPdfReport();
      } else {
        this.getExcelReport();
      }
    },

    getPdfReport() {
      var request = {
        companyId: this.$session.get('companyId'),
        filter: {
          date: this.formatDate(this.date),
          doctorId: this.doctorId,
          shiftId: this.shiftId
        }
      };

      this.$http.post("getshiftwisetokenreportpdf", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
      })
      .then(response => {
        window.open(response.data.data.filePath);
      });
    },

    getExcelReport() {
      var request = {
        companyId: this.$session.get('companyId'),
        filter: {
          date: this.formatDate(this.date),
          doctorId: this.doctorId,
          shiftId: this.shiftId
        }
      };

      this.$http.post("getshiftwisetokenreportxls", JSON.stringify(request), {
        headers: { "Content-Type": "application/json" }
      })
      .then(response => {
        window.open(response.data.data.filePath);
      });
    }
  }
}
</script>

<style scoped>
.cHeight {
  min-height: 80vh;   
}
.inputField {
  height: 36px;
  width: 100%;
}
.label {
  font-size: 13.2px;
  font-weight: 600;
  padding-top: 6px;
  display: inline-block;
}
</style>